<script>
export default {
    name: "RemoveClaim",

    props: {

        showModal: Boolean,
        claims: Array,
    },

    methods: {

        saveData() {

            this.$root.loading=true;
            this.$http.post(`Accounts/RemoveClaimsFromBatch`, 
                { removeClaimFromBatchDetails: this.claims, })
                    .then(() => {
                        this.$emit(`refresh`);
                        this.$root.loading=false;
                        this.$emit(`closeModal`);
                }).catch(() => { this.$root.loading=false; });
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Remove Claims from batch</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full text-center">
            <h5 class="text-base text-red-600">
                Confirm  remove {{ claims.length }} claims from batch</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Cancel</button>
        <button 
            @click.prevent="saveData"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-check"></i> Save</button>
      </template>
    </tail-modal>
</template>